import React, { useMemo } from "react";
import { Row, Col, Card } from "antd";
import { Bar } from "@ant-design/plots";

const COLORS = ["#69b1ff"];

const FALLBACK = [
    { labelName: "Mon", value: 0 },
    { labelName: "Tue", value: 0 },
    { labelName: "Wed", value: 0 },
    { labelName: "Thu", value: 0 },
    { labelName: "Fri", value: 0 },
    { labelName: "Sat", value: 0 },
    { labelName: "Sun", value: 0 },
];

function toRows(data) {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.data)) return data.data;
    return FALLBACK;
}

function totalOf(rows) {
    return (rows || []).reduce((acc, r) => acc + (Number(r.value) || 0), 0);
}

const setChartConfig = (rows) => {
    const data = toRows(rows);
    const total = totalOf(data) || 1;

    const maxVal = Math.max(...data.map(d => Number(d.value) || 0), 0);
    const yMax = Math.ceil((maxVal * 1.15) || 10);

    return {
        data: data.length ? data : FALLBACK,
        xField: "value",
        yField: "labelName",

        markBackground: {
            label: {
                text: ({ originData }) => {
                    const v = Number(originData?.value) || 0;
                    const pct = Math.round((v / total) * 100);
                    return `${pct}% | ${v.toLocaleString()}`;
                },
                position: "right",
                dx: 80,
                style: {
                    fill: "#8c8c8c",
                    fillOpacity: 1,
                    fontSize: 14,
                },
            },
            style: { fill: "#f2f2f2" },
        },

        axis: {
            x: { tick: false, title: false },
            y: {
                grid: false,
                tick: false,
                label: false,
                title: false,
            },
        },

        scale: {
            y: { domain: [0, yMax] },
        },

        color: COLORS[0],

        interaction: { elementHighlight: false },

        tooltip: {
            fields: ["labelName", "value"],
            formatter: (d) => ({
                name: d.labelName,
                value: (Number(d.value) || 0).toLocaleString(),
            }),
        },
    };
};

const TripleRightLastWeekBar = ({ data, isLoading }) => {
    const rows = useMemo(() => toRows(data), [data]);
    const config = useMemo(() => setChartConfig(rows), [rows]);

    return (
        <Card
            title="Triple right by day (last week)"
        >
            <Row gutter={24}>
                <Col span={24}>
                    <Bar style={{ width: '100%' }} {...config} loading={isLoading} className="p-0 m-0" />
                </Col>
            </Row>
        </Card>
    );
};

export default TripleRightLastWeekBar;
